/**
 * Safely extract a displayable string from flow execution result.
 * Prevents [object Object] when result/ai_response/etc. are objects.
 *
 * @param {unknown} data - Flow result (update.data, pollData, structuredOutput, etc.)
 * @param {string} [fallback] - Fallback when no string found
 * @returns {string} Displayable string
 */
export function toDisplayString(data, fallback = 'Flow completed successfully') {
  if (data == null) return fallback;
  if (typeof data === 'string') return data;

  if (typeof data === 'object') {
    // Prefer known string fields (order matters)
    const candidates = [
      data.ai_response,
      data.message,
      data.response,
      data.output,
      data.text,
      data.data,
      data.result,
    ];
    for (const c of candidates) {
      if (typeof c === 'string' && c) return c;
      if (typeof c === 'object' && c != null) {
        // Nested: { result: { ai_response: "..." } }
        const nested = toDisplayString(c, '');
        if (nested) return nested;
      }
    }
    // Last resort: stringify for debugging
    try {
      return JSON.stringify(data, null, 2);
    } catch {
      return fallback;
    }
  }

  return String(data);
}
